module.exports = require('./feedforwardNeuralNetwork');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fnn/src/index.js
 ** module id = 142
 ** module chunks = 0
 **/